import React from 'react';
import { useState } from 'react';
import { auth } from '../../config/firebaseConfig';
import { useGoogleLogin } from '@react-oauth/google';
import { Button, Container, Toast, ToastContainer } from 'react-bootstrap';

function GoogleSyncButton() {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const triggerToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const user = auth.currentUser;
      if (!user) {
        triggerToast('Utilisateur non connecté.', 'danger');
        return;
      }

      try {
        const URL_DE_VOTRE_API = 'https://us-central1-todo2023-66b6f.cloudfunctions.net/echangerCodeGoogleV2';
        // const URL_DE_VOTRE_API = 'https://echangercodegooglev2-edwdvhhlta-uc.a.run.app';
        const response = await fetch(URL_DE_VOTRE_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: codeResponse.code, userId: user.uid }),
        });

        if (response.ok) {
          triggerToast('Google Agenda synchronisé', 'success');
        } else {
          triggerToast('Erreur lors de la liaison avec Google.', 'danger');
        }
      } catch (error) {
        triggerToast('Impossible de joindre le serveur.', 'danger');
        console.error('Erreur de liaison Google Agenda : ', error);
      }
    },
    flow: 'auth-code',
    scope: 'openid profile email https://www.googleapis.com/auth/calendar',
    redirect_uri: 'postmessage',
    prompt: 'consent',
    accessType: 'offline',
  });

  return (
    <Container fluid>
        <div className="d-flex justify-content-center my-3">
          <Button
            variant="danger"
            className="fw-semibold d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
            onClick={() => login()}
          >
            Lier mon Google Agenda
          </Button>
        </div>

      <ToastContainer position="bottom-end" className="py-5" style={{ position: 'fixed', top: '15px', zIndex: 9999 }}>
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={toastVariant}
          className="text-white shadow-lg border-0"
        >
          <div className="d-flex align-items-center p-2">
            <Toast.Body className="d-flex justify-content-between align-items-center py-2 px-3">
              <i className="material-icons me-2" style={{ verticalAlign: 'middle' }}>
                {toastVariant === 'success' ? 'check_circle' : 'error'}
              </i>
              <span className="fw-semibold" style={{ letterSpacing: '0.2px' }}>{toastMessage}</span>
            </Toast.Body>
            <Button
              variant="close"
              variant-white="true"
              className="me-2 m-auto btn-close-white"
              onClick={() => setShowToast(false)}
              aria-label="Fermer"
            />
          </div>
        </Toast>
      </ToastContainer>
    </Container>
  );
}

export default GoogleSyncButton;

